import * as types from './types';

export const connected = () => ({
  type: types.CONNECTED
});

export const disconnected = () => ({
  type: types.DISCONNECTED
});
